module.exports = __webpack_public_path__ + "img/snorkeling-15.d52647eb.png";